import { render, staticRenderFns } from "./PriceInput.vue?vue&type=template&id=afc9a7f6&scoped=true&"
import script from "./PriceInput.vue?vue&type=script&lang=js&"
export * from "./PriceInput.vue?vue&type=script&lang=js&"
import style0 from "./PriceInput.vue?vue&type=style&index=0&id=afc9a7f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc9a7f6",
  null
  
)

export default component.exports